import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Buefy from 'buefy'
import plupload from 'plupload'
import PluploadES from './services/Plupload-ES'
import ApiService from './services/ApiService'
import VueJwtDecode from 'vue-jwt-decode'
import VeeValidate, { Validator } from 'vee-validate'
import messagesEs from 'vee-validate/dist/locale/es'
import constantes from './services/Constantes'
import globalMixin from './mixins/GlobalMixin'
import VueScrollTo from 'vue-scrollto'
import moment from 'moment'
// import 'buefy/dist/buefy.css' // Descomentar esta linea para usar estilos por defecto de Buefy

// Sobre escritura de prototipo de funcion "toJson" utilizada por JSON.stringify
// eslint-disable-next-line no-extend-native
Date.prototype.toJSON = function () { return moment(this).format() }

Vue.config.productionTip = false

// Mensajes en español para plupload
plupload.addI18n(PluploadES)

Object.defineProperty(Vue.prototype, '$plupload', { value: plupload })
const apiService = new ApiService(axios, VueJwtDecode)
Object.defineProperty(Vue.prototype, '$apiService', { value: apiService })
Object.defineProperty(Vue.prototype, '$VueJwtDecode', { value: VueJwtDecode })
Object.defineProperty(Vue.prototype, '$constantes', { value: constantes })

Vue.use(Buefy, {
  defaultToastDuration: 1000,
  defaultSnackbarDuration: 1000,
  defaultNotificationDuration: 1000,
  defaultDatepickerYearsRange: [-100, 10],
  defaultNoticeQueue: false,
  defaultDialogCancelText: 'Cancelar',
  defaultDayNames: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  defaultMonthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'May', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  defaultDatepickerMobileNative: false,
  defaultTimepickerMobileNative: false,
  defaultTimeParser: function (dateString) {
    const dateMoment = moment(dateString, 'DD/MM/YYYY H:mm')
    return dateMoment.toDate()
  },
  defaultTimeFormatter: function (date) {
    return date.toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit', timeStyle: 'short', timeZone: 'America/Buenos_Aires' })
  },
  defaultDateParser: function (dateString) {
    const dateMoment = moment(dateString, 'DD/MM/YYYY')
    return dateMoment.toDate()
  },
  defaultDateFormatter: function (date) {
    // Fix para datepicker de buefy cuando se utiliza un periodo
    if (date.constructor.name === 'Array') {
      if (date.length === 2) { // Si son dos posiciones
        return date[0].toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' - ' + date[1].toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' })
      } else { // Sino retorna vacío
        return ''
      }
    } else {
      return date.toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' })
    }
  }
})

// Config de Vee-validate
Validator.localize({ es: messagesEs })
Vue.use(VeeValidate, { locale: 'es' })

// Mixin global
Vue.mixin(globalMixin)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1000,
  easing: 'ease',
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
